import { SagaCancelledError } from '@lib/redux/deferred';

/**
 * `.catch` handler for an awaited request action (lib/redux/deferred.ts): a `takeLatest`
 * supersession rejects the deferred with `SagaCancelledError`, but the Zustand actions the
 * `.redux.ts` twins replace never rejected for that reason — a newer request simply took over.
 * Resolve `fallback` in that one case and rethrow anything else.
 */
export const resolveIfCancelled =
    <T>(fallback: T) =>
    (error: unknown): T => {
        if (error instanceof SagaCancelledError) {
            return fallback;
        }
        throw error;
    };
